import { render } from "./barBottom.vue?vue&type=template&id=69a2cab0&scoped=true"
import script from "./barBottom.vue?vue&type=script&lang=js"
export * from "./barBottom.vue?vue&type=script&lang=js"

import "./barBottom.vue?vue&type=style&index=0&id=69a2cab0&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a2cab0"]])

export default __exports__